import $            from 'jquery';
import sweetalert   from 'sweetalert';
import settings     from '../settings';

export default () => {
    $('.js-invite-form').each(function(k, v) {
        let $me = $(v),
            $my_field = $me.find('.js-invite-form__emails'),
            $my_btn = $me.find('.js-invite-emails__submit'),
            url = $me.attr('action'),
            separator = $my_field.data('separator');

        $me.on('submit', function(ev) {
            ev.preventDefault();

            let emails = $my_field.val(),
                response;
            if (!! emails) {
                emails = separator ? emails.split(separator) : [ emails ];

                for (var i = emails.length - 1; i >= 0; i--) {
                    emails[i] = emails[i].trim();
                };

                response = $.ajax({
                    headers: settings.api_headers,
                    url: url,
                    data: {
                        invite_emails: emails
                    },
                    type: 'POST',
                    dataType: 'json'
                });

              response.always(function(data, textStatus, jqXHR) {
                  if (data.status == 200) {
                      sweetalert({
                          title: 'Success!',
                          text: 'Your invites have been sent!',
                          type: 'success'
                      });
                      $my_field.val('');
                  } else {
                      sweetalert({
                          title : 'Sorry!',
                          text  : 'There was a problem sending your invites.',
                          type  : 'error'
                      });
                  }
              });
            } else {
                sweetalert({
                    title: "Form Error",
                    text: "Please enter at least one email address to invite.",
                    type: "warning"
                });
            }
        })
    });
}
